export default "__VITE_ASSET__FYvkwla___"